import { motion } from 'framer-motion';

export default function FamilySection() {
  return (
    <section id="familie" className="relative pt-16 lg:pt-24 pb-24 bg-white overflow-hidden min-h-[600px] flex items-center">
      {/* Desktop Image - Full bleed on left */}
      <div className="hidden lg:block absolute left-0 top-0 bottom-0 w-1/2">
        <img 
          src="https://assets.auxodev.dk/assets/2cadb5d8-c2c5-4850-ae22-0167799adce5/62b82a96-b4e6-4bdf-bc07-3bbd2bf1b325.jpg" 
          alt="Familie og ældre tryghed"
          className="w-full h-full object-cover"
        />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full relative z-10">
        <div className="flex flex-col lg:flex-row items-center">
          {/* Mobile Image */}
          <div className="lg:hidden w-full mb-12">
            <img 
              src="https://assets.auxodev.dk/assets/2cadb5d8-c2c5-4850-ae22-0167799adce5/f94af8b1-3040-45d8-b475-9788d9622e8b.jpg" 
              alt="Familie og ældre tryghed"
              className="w-full h-auto object-cover"
            />
          </div>

          {/* Text Content */}
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="lg:w-1/2 lg:ml-auto lg:pl-20"
          >
            <span className="text-black font-bold tracking-wider uppercase text-sm mb-4 block">
              Vi står parat til at hjælpe
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-[#103B66] mb-6 leading-tight">
              Har du eller en pårørende behov for hjælp eller vejledning?
            </h2>
            <div className="space-y-6 text-lg text-slate-600 leading-relaxed">
              <p>
                Mange ældre og sårbare føler sig usikre på nettet, men familien har ikke altid tid eller mulighed for at hjælpe i hverdagen.
              </p>
              <p className="font-medium text-slate-900">
                Hos Online Tryghed hjælper vi professionelt, roligt og tålmodigt — uden stress og uden teknisk jargon.
              </p>
              <p>
                Vi fungerer som den ekstra hånd, der sikrer, at dine nærmeste kan færdes trygt digitalt, uanset om det handler om MitID, mails eller bare at få tabletten til at virke.
              </p>
            </div>
            
            <div className="mt-10 p-8 bg-white shadow-xl">
              <p className="italic text-slate-600">
                "Det giver mig en enorm ro i maven at vide, at min far altid kan ringe til Online Tryghed, hvis han bliver i tvivl om en mail eller et opkald."
              </p>
              <div className="mt-4 font-bold text-[#103B66]">— Pårørende, København</div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
